import script from "./RateTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./RateTable.vue?vue&type=script&setup=true&lang=ts"

import "./RateTable.vue?vue&type=style&index=0&id=70bb0020&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70bb0020"]])

export default __exports__